module.exports = __webpack_public_path__ + "static/media/tds.e979759b.png";